import { LegacyOttTrailerPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export function getPromoOtt(trailer: LegacyOttTrailerPlayerBaseInfoContent) {
    if (trailer.__typename === 'OttTrailer') {
        return trailer;
    }
}
